"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnmatchedExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224185" id="request-inspection" className="dark bg-background text-foreground relative flex flex-col items-center justify-center py-48 md:py-64 overflow-hidden [clip-path:polygon(50%_0,100%_8vw,100%_calc(100%-8vw),50%_100%,0_calc(100%-8vw),0_8vw)]">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)]" />

      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center px-4 max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="font-default text-5xl md:text-7xl lg:text-8xl mb-12 tracking-tighter uppercase">Don't Wait for Damage, Prevent It</h2>
        <Button size="lg" asChild className="h-16 px-12 text-lg rounded-full tracking-widest bg-primary text-primary-foreground hover:scale-105 transition-all duration-300 shadow-none">
          <Link to="/ContactPage">
            REQUEST TERMITE INSPECTION
          </Link>
        </Button>
      </div>
    </section>;
}